import {
    BootstrapTooltip,
    BinsBox,
    StartTrainingBtn, FineTuneBtn
} from '../Style/AutoProjectImageCollectionTab.style';
import {Box} from '../../../ui-library';
import {TabPanelView} from '../../TabPanel';
import React from 'react';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {AutoProjectStatusTabs} from '../../AutoProjectStatusTabs/Config/AutoProjectStatusTabs.config';
import {IPropsView} from '../Config/AutoProjectImageCollectionTab.types';
import {ChipStyle, ClassFlowPhase, StatusMessageBox, ProjectFlowPhase} from '../../../pages/AutoProject/Config/AutoProject.constants';
import AutoStartTrainingModalView from '../../AutoStartTrainingModal/View/AutoStartTrainingModal.view';
import useAutoProjectImageCollectionTab from '../Controller/AutoProjectImageCollectionTab.controller';
import {AutoProjectStatusBinView} from '../../AutoProjectStatusBin';
const AutoProjectImageCollectionTabView = ({value, autoProjectState, goToManualRefinement, startTrainingBtn, setValue}: IPropsView) => {
    const disableTrainBtn = autoProjectState.messageBoxFlowPhase !== StatusMessageBox.ReadyForTraining || autoProjectState.isTrainingStarted;
    const disableRefineBtn = autoProjectState.classes.length > 0
        ? !autoProjectState.classes.some((tag) => tag.flowPhase === ClassFlowPhase.ManualRefinementReady) ||
        autoProjectState.projectFlowPhase === ProjectFlowPhase.Stopped ||
        autoProjectState.projectFlowPhase === ProjectFlowPhase.Error : true;
    const {openTrainingModal, setOpenTrainingModal} = useAutoProjectImageCollectionTab();
    const tooltipText = autoProjectState.isTrainingStarted ? _SYSTEM_TITLES.autoExecuteTrainingTooltipAfterPress : _SYSTEM_TITLES.autoExecuteTrainingTooltipBeforePress;
    const isChipsDisabled = autoProjectState.projectFlowPhase === ProjectFlowPhase.Stopped || autoProjectState.projectFlowPhase === ProjectFlowPhase.Error;

    return (
        <>
            <TabPanelView value={value} index={AutoProjectStatusTabs.ImageCollection}>
                <AutoStartTrainingModalView
                    open={openTrainingModal}
                    setOpen={setOpenTrainingModal}
                    autoProjectState={autoProjectState}
                    startTrainingBtn={startTrainingBtn}
                    setValue={setValue}
                />
                <BinsBox>
                    <AutoProjectStatusBinView
                        binTitle={_SYSTEM_TITLES.autoProjectProcessingAIDataBin}
                        chipsArr={autoProjectState.classes.filter((tag) => tag.flowPhase === ClassFlowPhase.InCluster || tag.flowPhase === ClassFlowPhase.ManualRefinementProcessPending)}
                        chipStyle={ChipStyle.CollectingImages}
                        childBtn={<></>}
                        isChipsDisabled={isChipsDisabled}/>
                    <AutoProjectStatusBinView
                        binTitle={_SYSTEM_TITLES.autoProjectReadyForFineTuneBin}
                        chipsArr={autoProjectState.classes.filter((tag) => tag.flowPhase === ClassFlowPhase.ManualRefinementReady)}
                        chipStyle={ChipStyle.ReadyForMr}
                        childBtn={<FineTuneBtn onClick={goToManualRefinement} disabled={disableRefineBtn} variant='outlined' size='medium'>{_SYSTEM_TITLES.imageCollectionTabRefineBtn}</FineTuneBtn>}
                        isChipsDisabled={isChipsDisabled}/>
                    <AutoProjectStatusBinView
                        binTitle={_SYSTEM_TITLES.autoProjectReadyForTrainingBin}
                        chipsArr={autoProjectState.classes.filter((tag) => tag.flowPhase === ClassFlowPhase.TrainingReady)}
                        chipStyle={ChipStyle.ReadyForTraining}
                        childBtn={
                            <>{disableTrainBtn
                                ? <>
                                    <BootstrapTooltip title={tooltipText} placement='top'>
                                        <Box>
                                            <StartTrainingBtn disabled={disableTrainBtn} variant='outlined' size='medium' onClick={() => setOpenTrainingModal(true)}>{_SYSTEM_TITLES.imageCollectionTabStartBTn}</StartTrainingBtn>
                                        </Box>
                                    </BootstrapTooltip>
                                </> : <StartTrainingBtn disabled={disableTrainBtn} variant='outlined' size='medium' onClick={() => setOpenTrainingModal(true)}>{_SYSTEM_TITLES.imageCollectionTabStartBTn}</StartTrainingBtn>
                            }</>}
                        isChipsDisabled={isChipsDisabled}/>
                </BinsBox>
            </TabPanelView>
        </>
    );
};

export default AutoProjectImageCollectionTabView;
